import uiRouter, { StateProvider } from '@uirouter/angularjs';
import { ThemesDataResolver, TenantDataResolver } from '@b2b/common/resolvers';
import angular from 'angular';
import { OrderDataResolver } from '../resolvers';
import { OrderDetailsControllerModule } from './controllers/OrdersDetailController';
import { OrderDetailsEmailStatusView } from './emailStatus/emailStatus';
import { OrderDetailsFormsView } from './forms/forms';
import { OrderDetailsTransactionsView } from './transactions/transactions';

export const OrdersDetailView = angular
  .module('acme.view.application.orders.detail', [
    uiRouter,
    'ui.bootstrap',
    'acme.common.service.api',
    'acme.common.directive.detailList',
    'acme.common.directive.resendEmail',
    OrderDetailsControllerModule,
    OrderDetailsEmailStatusView,
    OrderDetailsTransactionsView,
    OrderDetailsFormsView,
    'acme.view.application.dataGrid.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.orders.detail',
      url: '/:orderId/detail',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'OrdersDetailController',
          controllerAs: '$ctrl',
          // Assumes the view is entirely self contained
          templateUrl: 'views/application/views/orders/detail/detail.tpl.html',
        },
      },
      data: {
        pageTitle: 'Order Details',
        permissions: ['ORDER_VIEW', 'ACCT_ORDERS_VIEW'],
      },
      resolve: {
        OrderData: OrderDataResolver(),
        ThemesData: ThemesDataResolver(),
        TenantData: TenantDataResolver(),
      },
    });

    $stateProvider.state({
      name: 'application.orders.detail.summary',
      url: '/summary',
      views: {
        'subviews-main': {
          templateUrl: 'views/application/views/orders/detail/summary.tpl.html',
        },
      },
    });
  }).name;
